import { render, staticRenderFns } from "./NewPatientCenter.vue?vue&type=template&id=441bd541&scoped=true"
import script from "./NewPatientCenter.vue?vue&type=script&lang=ts"
export * from "./NewPatientCenter.vue?vue&type=script&lang=ts"
import style0 from "./NewPatientCenter.vue?vue&type=style&index=0&id=441bd541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441bd541",
  null
  
)

export default component.exports